export default "__VITE_ASSET__CC2kpMQG__"